import { FC, useMemo } from "react";
import { AppPartType } from "../../../types";
import CommonDatePicker from "@lhd/components/CommonDatePicker";
import moment from "moment";
import { DATE_TIME_FORMAT } from "@lhd/constants";

type PropsType = {
  appPart: AppPartType;
};
const Date: FC<PropsType> = ({ appPart }) => {
  const { default_value, calc_type } = appPart;
  const value = useMemo(() => {
    if (calc_type === "date") {
      return moment();
    }
    if (default_value) {
      return moment(default_value);
    }
    return null;
  }, [calc_type, default_value]);
  return (
    <CommonDatePicker
      style={{ width: "100%" }}
      disabled
      value={value}
      displayFormat={DATE_TIME_FORMAT.DATE_JP}
      placeholder="日付を選択"
      allowClear={false}
    />
  );
};

export default Date;
